module.exports = __webpack_public_path__ + "static/img/mx.784b4934.svg";